import { ForgotPasswordScreen } from '@/screens/auth/forgot-password-screen';
export default ForgotPasswordScreen;
